/** eBay Inventory API product field limits */
export const EBAY_TITLE_MAX = 80;
export const EBAY_BRAND_MAX = 65;
export const EBAY_ASPECT_VALUE_MAX = 50;

export const EBAY_FIELD_LIMITS = {
    title: EBAY_TITLE_MAX,
    brand: EBAY_BRAND_MAX,
    size: EBAY_ASPECT_VALUE_MAX,
    'color / style': EBAY_ASPECT_VALUE_MAX,
};

export const getEbayFieldLimit = (fieldName) => EBAY_FIELD_LIMITS[fieldName] ?? null;

export const getEbayFieldHelperText = (fieldName, value = '') => {
    const limit = getEbayFieldLimit(fieldName);
    if (!limit) return null;
    const length = String(value ?? '').length;
    if (length <= limit) return null;
    if (fieldName === 'title') return `Title is over eBay's ${limit} character limit`;
    return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is over eBay's ${limit} character limit`;
};
